
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const HeroSection = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/browse?search=${encodeURIComponent(searchQuery)}`);
    }
  };
  
  return (
    <section className="bg-gradient-to-br from-white to-gray-100 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="w-full lg:w-1/2 lg:pr-12 mb-10 lg:mb-0 animate-fade-in" style={{ animationDelay: '0.1s' }}>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight">
              Connect with <span className="text-crimson">Alumni</span> from Top Institutions
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Get personalized guidance on applications, essays, interviews, and more from graduates of prestigious universities.
            </p>
            
            <form onSubmit={handleSearch} className="flex w-full max-w-md">
              <div className="relative flex-grow">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <Input 
                  type="text" 
                  placeholder="Search alumni by name, school, expertise..." 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10 pr-4 py-6 w-full border border-silver/30 focus-within:border-crimson"
                />
              </div>
              <Button type="submit" className="ml-2 bg-crimson hover:bg-crimson-dark">
                Search
              </Button>
            </form>
            
            <div className="mt-6 text-sm text-gray-500">
              <p>Popular searches: Resume Review, Essay Editing, Interview Prep</p>
            </div>
          </div>
          
          <div className="w-full lg:w-1/2 animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-crimson/10 rounded-full"></div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-silver/20 rounded-full"></div>
              <img 
                src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80" 
                alt="Students and alumni" 
                className="rounded-lg shadow-lg z-10 relative"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
